import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import TurnRightIcon from "@mui/icons-material/TurnRight";
import CloseIcon from "@mui/icons-material/Close";
import Pagination from "../../../components/Pagination";
import Table from "../../../components/table";
import usePagination from "../../../components/usePagination";
import api from "../../../api/api";
import * as bootstrap from "bootstrap";
import "../../Freight/Common/form.css";
import Breadcrumbs from "../../../components/Breadcrumbs";
import SearchIcon from "@mui/icons-material/Search";
 
 
const FILTER_KEY = "salesDashboardFilters";
 
const SalesClients = () => {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState("");
 
  useEffect(() => {
    const fetchClients = async () => {
      setLoading(true);
      try {
        const stored = localStorage.getItem(FILTER_KEY);
        const filters = stored ? JSON.parse(stored) : null;
 
        const response = await api.get("/sales/clients");
        let data = response.data.clients || [];
 
        // FRONTEND FILTERING
        if (filters) {
          const { startDate, endDate, selectedUser } = filters;
 
          if (startDate && endDate) {
            const from = new Date(startDate);
            const to = new Date(endDate);
 
            data = data.filter((c) => {
              const created = new Date(c.created_at);
              return created >= from && created <= to;
            });
          }
 
          if (selectedUser) {
            data = data.filter((c) => c.created_by === selectedUser);
          }
        }
 
        setClients(
          data.map((c) => ({
            ...c,
            follow_up_number: parseInt(c.follow_up_number, 10) || 0,
          })),
        );
      } catch (err) {
        console.error(err);
        setError("Failed to fetch clients");
      } finally {
        setLoading(false);
      }
    };
 
    fetchClients();
  }, []);
 
  /* SEARCH */
  const filteredBySearch = clients.filter((client) => {
    const term = search.toLowerCase();
    return (
      client.first_name?.toLowerCase().includes(term) ||
      client.last_name?.toLowerCase().includes(term) ||
      client.company_name?.toLowerCase().includes(term)
    );
  });
 
  /* PAGINATION */
  const {
    currentPage,
    itemsPerPage,
    totalPages,
    totalItems,
    currentItems,
    goToPage,
    handleItemsPerPageChange,
  } = usePagination(filteredBySearch, 5);
 
  /* TOOLTIP */
  useEffect(() => {
    const tooltipTriggerList = Array.from(
      document.querySelectorAll('[data-bs-toggle="tooltip"]'),
    );
    tooltipTriggerList.forEach((el) => new bootstrap.Tooltip(el));
  }, [filteredBySearch, currentPage]);
 
  if (error) return <p className="text-danger">{error}</p>;
 
  const columns = [
    { label: "Client Name", render: (c) => `${c.first_name} ${c.last_name}` },
    { label: "Company Name", render: (c) => c.company_name },
    { label: "Industry Type", render: (c) => c.customer_industry },
    { label: "Handled By", render: (c) => c.created_by },
    { label: "Follow Up No", render: (c) => c.follow_up_number },
    {
      label: "Created At",
      render: (c) => {
        const [d, t] = c.created_at.split("T");
        const [h, m] = t.split(":");
        const hr = h % 12 || 12;
        return `${d} ${hr}:${m} ${h >= 12 ? "PM" : "AM"}`;
      },
    },
    {
      label: "Action",
      render: (c) => (
        <>
          {c.follow_up_number > 1 && (
            <Link to="/sales-enquiries" state={{ enq_ids: [c.customer_id] }}>
              <TurnRightIcon fontSize="small" />
            </Link>
          )}
          {c.follow_up_number === 1 && (
            <Link to={`/sales-view-enquiry/${c.customer_id}?type=followup`}>
              <VisibilityIcon fontSize="small" />
            </Link>
          )}
        </>
      ),
    },
  ];
 
  return (
    <>
      <Breadcrumbs />
 
        {/* SEARCH INPUT */}
      <div className="mb-3 position-relative" style={{ maxWidth: "100%" }}>
        <input
          type="search"
          className="form-control ps-5"
          placeholder="Search by Client Name or Company Name..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
 
        <SearchIcon
          style={{
            position: "absolute",
            left: "12px",
            top: "50%",
            transform: "translateY(-50%)",
            cursor: "pointer",
            color: "#6b7280",
            width:"16px",
            height:"16px"
          }}
        />
      </div>
 
      <Table
        columns={columns}
        data={currentItems}
        loading={loading}
        emptyMessage="No Clients found."
        itemsPerPage={itemsPerPage}
        pagination={
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={goToPage}
            itemsPerPage={itemsPerPage}
            onItemsPerPageChange={handleItemsPerPageChange}
            totalItems={totalItems}
          />
        }
      />
    </>
  );
};
 
export default SalesClients;